<template>
  <!-- Верхняя панель -->
  <v-system-bar color="rgba(225,225,225,0.7)" style="min-height: 32px;">
    <v-img
        src="Логотип.svg"
        max-height="24"
        max-width="24"
        class="mx-2"
        contain
        eager
    />
    <span class="app-title">sagi</span>
    <v-spacer/>
    <v-btn size="small" icon="mdi-logout" variant="text" @click="logout"></v-btn>
  </v-system-bar>

  <!-- Контент -->
  <v-container class="main-container d-flex flex-column align-center justify-center fill-height text-center pt-6">

    <v-alert type="success" rounded="lg" dense class="mb-2"    border="end">
      <strong class="text-h6">Вы успешно авторизованы!</strong><br>
      Используйте <strong>Sagi</strong> для накопления и списания баллов в приложении
      <v-btn
          variant="tonal"
          size="x-small"
          href="https://kassa.moysklad.ru/"
          prepend-icon="mdi-open-in-new"
          target="_blank"
          class="ml-2 text-none"
      >
        Касса МойСклад
      </v-btn>
    </v-alert>

    <!-- Карусель -->
    <v-carousel
        class="mb-10 rounded-lg"
        v-model="current"
        show-arrows="hover"
        progress="primary"
        cycle
        height="660"
        hide-delimiter-background
    >
      <v-carousel-item
          v-for="(slide, idx) in slides"
          :key="idx"
          class="rounded-lg"
      >
        <v-img
            :src="slide.img"
            eager
            class="rounded-lg"
            aspect-ratio="16/9"
        >
        </v-img>
      </v-carousel-item>
    </v-carousel>

    <v-row>
      <v-col
          v-for="(card, idx) in cards"
          :key="idx"
          cols="4"
      >
        <v-card min-height="160"
                rounded="xl"
                class="mx-auto bg-grey-lighten-5" link
                :title="card.title"
                variant="flat"

        >
          <!--            <v-card-title class="font-weight-black text-md-subtitle-1">
                        {{ card.title }}
                      </v-card-title>-->
          <v-card-text class="pt-4">
            {{ card.text }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import {ref} from "vue";
import {useUserStore} from '@/stores/user'

const userStore = useUserStore()
const slides = [
  {
    img: "Баннер-1.png",
    title: "Добро пожаловать!",
    subtitle: "Участвуйте в нашей программе лояльности и получайте бонусы.",
    buttonText: "Подробнее"
  },
  {
    img: "Баннер-2.png",
    title: "Собирайте баллы",
    subtitle: "Получайте баллы за каждую покупку и обменивайте их на подарки.",
    buttonText: "Узнать как"
  },
  {
    img: "Баннер-3.png",
    title: "Эксклюзивные предложения",
    subtitle: "Доступ к акциям только для участников.",
    buttonText: "Акции"
  },
  {
    img: "Баннер-4.png",
    title: "Подарки на день рождения",
    subtitle: "Получайте приятные сюрпризы в свой праздник!",
    buttonText: "Получить подарок"
  },
  {
    img: "Баннер-5.png",
    title: "Удобное приложение",
    subtitle: "Следите за балансом и новостями прямо в телефоне.",
    buttonText: "Скачать"
  },
];

const cards = [
  {
    title: "Бонусная программа",
    text: "15 видов бонусов, вы можете сами настроить срок сгорания и активации, размер и количество бонусов"
  },
  {
    title: "Коммуникация с клиентами",
    text: "Авто-уведомления на WhatsApp, Массовые Пуш-уведомления, Обратная связь - отзывы от реальных клиентов, массовый опрос всех клиентов"
  },
  {
    title: "CRM (сквозная аналитика)",
    text: "Аналитика клиентов, продаж и маркетинга, ROI"
  },
  {
    title: "База клиентов",
    text: "Учет клиентов и истории их покупок, сегментация и поиск потерянных клиентов"
  },
  {
    title: "Кросс-маркетинг",
    text: "Скрещивайте клиентскую базу с другими бизнесами и приводите новых клиентов"
  },
  {
    title: "Мобильное приложение",
    text: "Готовое мобильное приложение с брендированной виртуальной бонусной картой, информацией о бизнесе и бонусах"
  },
];

const logout = async () => {
  userStore.clearUserData();
}

const current = ref(0);
</script>

<style scoped>
.main-container {
  max-width: 1200px;
  margin: 0 auto;
}
</style>
